exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-scrollbar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 15px;\n  background-color: #f1f1f1;\n  border-top: 2px solid #ccc;\n  z-index: 999999;\n}\n.scroll-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-color: #888;\n  border-radius: 6px;\n  cursor: pointer;\n  -webkit-transition: left 0.1s;\n  transition: left 0.1s;\n}\n.sticky-table-container .el-table--scrollable-x .el-table__body-wrapper {\n  overflow-x: hidden;\n}\n", ""]);

// exports
